import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ms-release-guidelines',
  templateUrl: './release-guidelines.component.html',
  styleUrls: ['./release-guidelines.component.scss']
})
export class ReleaseGuidelinesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
